<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <loading-spinner v-if="isLoading"></loading-spinner>
                <checkbox-table v-else :title="$t('title.payment_fee')" icon="list" :columns="tableColumns"
                    :data="feeTypes" @selected-items="handleSelectedItems">
                    <template v-slot:bottom-content>
                        <div class="d-flex align-items-end text-right flex-column mb-20 absent--text mr-3 mt-10">
                            <p class="text-h5 font-weight-medium">
                                {{ $t('label.total_amount') }}
                            </p>
                            <p class="text-body-1 font-weight-light">
                                KRW {{ totalAmountKrw }} / USD {{ totalAmountUsd }}
                            </p>
                        </div>
                    </template>

                    <template v-slot:bottom-buttons>
                        <div class="d-flex mr-5">
                            <custom-button v-for="button in tableButtons" :key="button.idx" @click="button.action"
                                :label="button.label" color="primary" class="ml-auto mb-10" size="lg" gradient
                                rounded></custom-button>
                        </div>
                    </template>
                </checkbox-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import CheckboxTable from '@/components/Tables/CheckboxTable.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

import { getMemberFeeTypeColumns } from '@/views/PaymentView/columns';
import { accountApi } from '@/api/api';

export default {
    name: "MemberFeePayment",
    components: {
        CheckboxTable,
        CustomButton,
        LoadingSpinner,
    },
    data() {
        return {
            feeTypes: null,
            totalAmountKrw: 0,
            totalAmountUsd: 0,
            tableColumns: getMemberFeeTypeColumns([]),
            isLoading: false,
            tableButtons: [
                // {
                //     idx: 1,
                //     label: "KRW 결제",
                //     class: "md-gray md-round",
                //     action: this.temp,
                // },
                {
                    idx: 1,
                    label: this.$t('button.usd_payment'),
                    color: "accent",
                    action: this.handlePay,
                },
            ],
            selectedItems: [],
        }
    },
    methods: {
        handlePay() {
            const data = this.buildPaymentData(this.selectedItems);

            if (!data) {
                this.notifyVue({ message: this.$t('alert.select_fee'), style: "danger" });
                return;
            }

            this.requestPaypal(data);
        },
        handleSelectedItems(selectedItems) {
            this.selectedItems = selectedItems;
            this.calculateTotalAmount(this.selectedItems);
        },
        async requestPaypal(data) {
            // token 이 order id
            this.isLoading = true;
            await accountApi.requestCreatePaypalOrder(data)
                .then((response) => {
                    if (response && response.status === 200) {
                        window.location.href = response.data.approve_url;
                    } else {
                        this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
                    }
                })
                .catch(() => {
                    this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        calculateTotalAmount(selectedItems) {
            const totals = selectedItems.reduce(
                (acc, item) => {
                    acc.total_usd += item.fee_usd || 0;
                    acc.total_krw += item.fee_krw || 0;
                    return acc;
                },
                { total_usd: 0, total_krw: 0 }
            );

            this.totalAmountKrw = totals.total_krw;
            this.totalAmountUsd = totals.total_usd;
        },
        buildPaymentData(items) {
            if (items.length === 0) {
                return false;
            }

            const first = items[0];
            const orderName = items.length > 1 ? `${first.name} 외 ${items.length - 1} 건` : first.name;
            const feeTypeIdxs = items.map(item => item.idx);

            return {
                "order_name": orderName,
                "amount": this.totalAmountUsd,
                "currency_code": "USD",
                "fee_type_idxs": feeTypeIdxs,
            }
        },
        async fetchFeeTypes() {
            try {
                this.isLoading = true;
                const response = await accountApi.getFeeTypes();

                if (response && response.status === 200) {
                    this.feeTypes = response.data.response;
                }
            } catch {
                this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
            } finally {
                this.isLoading = false;
            }
        },
        /* ****************************************************************************************
        * 알럿
        * ****************************************************************************************/
        notifyVue({
            vertical = "top",
            horizontal = "right",
            message = "",
            style = "primary",
            icon = "priority_high",
        } = {}) {
            this.$notify({
                timeout: 8000,
                message: message,
                icon: icon,
                type: style,
                horizontalAlign: horizontal,
                verticalAlign: vertical,
            });
        }
    },
    mounted() {
        this.fetchFeeTypes();
    }
}
</script>
<style lang="scss" scoped>
.md-button-group {
    display: flex;
    justify-content: flex-end;
    margin: 10px;
}
</style>